export enum VincereUserStatusType {
    NOT_SYNCED = 'NOT_SYNCED',
    USER_SYNCED = 'USER_SYNCED',
    DATA_SYNCED = 'DATA_SYNCED',
    NO_VINCERE_USER = 'NO_VINCERE_USER',
    ERROR = 'ERROR'
}